import {Offer, DEAL_STATUSES} from '@chekin/core';
import {usePaymentSettings} from 'hooks';
import {usePostHogTrack, POSTHOG_EVENTS} from 'analytics';
import {CategoryTranslation} from 'components/upselling/CategoryTranslation';
import {usePathToOfferView} from 'components/upselling/usePathToOfferView';
import {OfferCardMark} from 'components/upselling/OfferCardMark';
import {formatPrice} from 'components/upselling/price';
import {getCategoryIcon} from './constants';
import {truncateText} from './utils';
import {
  Container,
  ImageWrapper,
  Image,
  CategoryBadge,
  StatusBadgeWrapper,
  ContentWrapper,
  TextWrapper,
  Title,
  Highlight,
  Price,
} from './styled';

type Props = {
  offer: Offer;
  className?: string;
  status?: DEAL_STATUSES;
};

const OfferCard = ({className, offer, status}: Props) => {
  const {getFullPathToOfferView} = usePathToOfferView({backToOfferList: true});
  const {currencySymbol} = usePaymentSettings();
  const {trackOfferEvent} = usePostHogTrack();

  const handleClick = () => {
    trackOfferEvent(POSTHOG_EVENTS.OFFER_DETAIL_OPENED, offer);
  };

  const CategoryIcon = offer.category ? getCategoryIcon(offer.category) : null;

  return (
    <Container to={getFullPathToOfferView(offer.id)} className={className} onClick={handleClick}>
      <ImageWrapper>
        <Image src={offer.image_url} alt={offer.title} />
        {status && (
          <StatusBadgeWrapper>
            <OfferCardMark status={status} />
          </StatusBadgeWrapper>
        )}
        {offer.category && CategoryIcon && (
          <CategoryBadge>
            <CategoryIcon size={14} />
            <CategoryTranslation category={offer.category} />
          </CategoryBadge>
        )}
      </ImageWrapper>
      <ContentWrapper>
        <TextWrapper>
          <Title>{offer.title}</Title>
          <Highlight>{truncateText(offer.highlight)}</Highlight>
        </TextWrapper>
        <Price>
          {formatPrice(currencySymbol)({
            priceType: offer.price_type,
            items: offer.items,
          })}
        </Price>
      </ContentWrapper>
    </Container>
  );
};

export {OfferCard};
